import { memo } from "react";
import { Link } from "react-router-dom";
import { Droplets, Leaf, Heart, ArrowRight } from "lucide-react";

const PILLARS = [
  {
    icon: Droplets,
    title: "Hand-cooked pearls",
    body: "Every morning, small batch, chewy all the way through. No sad gummy pearls here.",
  },
  {
    icon: Leaf,
    title: "Slow-steeped tea",
    body: "Real leaves, full infusions. Jasmine, oolong, matcha — the good stuff.",
  },
  {
    icon: Heart,
    title: "Real fruit + syrup",
    body: "Purees, pulps, and house syrups. No thin neon flavoring on our watch.",
  },
];

function CraftedWithLove() {
  return (
    <section data-testid="home-crafted-with-love" className="relative overflow-hidden">
      <div className="absolute inset-0 bp-scatter opacity-60 pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.18em] text-primary/80">Our craft</p>
            <h2 className="font-brand font-semibold text-[1.9rem] sm:text-3xl lg:text-4xl tracking-tight mt-2">
              Made with patience.<br />
              <span className="text-accent">Served with a big straw.</span>
            </h2>
            <p className="mt-4 text-muted-foreground text-[15px] sm:text-base leading-relaxed max-w-md">
              We don't cut corners. Our tea steeps longer, our pearls simmer slower, and every drink gets shaken by hand.
              You can taste it. (And chew it.)
            </p>
            <Link
              to="/about"
              data-testid="home-crafted-learn-more-link"
              className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-primary hover:text-primary/80"
            >
              Learn our story <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-3 gap-3 sm:gap-4">
            {PILLARS.map((p) => {
              const Icon = p.icon;
              return (
                <div
                  key={p.title}
                  className="bp-card p-5 sm:p-6 transition-transform hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-22px_rgba(91,63,209,0.35)]"
                >
                  <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary grid place-items-center">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-brand font-semibold text-lg mt-4">{p.title}</h3>
                  <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{p.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default memo(CraftedWithLove);
